<template>
	<transition name="slide">
    <div class="navs-map">
      <div class="navs-all">
        <img class="logo" src="~@/assets/images/logo_Institute.svg"/>
        <!-- <img class="logo" v-else src="~@/assets/images/logo_english.svg"/> -->
        <div
          class="primary-nav"
          @click.stop="jumpPage(nav)"
          @mouseenter="onMouseEnter(nav)"
          @mouseout="onMouseOut(nav)"
          v-for="(nav, index) in navigations"
          :key="index">
          {{ nav.name }}
        </div>
        <div class="lang-check">
        <span
          v-for="(lang, langIndex) in langs"
          :class="{ active: $i18n.locale === lang.type, [`lang-${lang.type}`]: true }"
          @click="langCheck(lang)"
          :key="langIndex">
          {{ lang.name }}
        </span>
        </div>
      </div>
      <div
        class="navs-wrapper"
        :class="`navs-order${navigation.order}`"
        v-for="(navigation, navIndex) in navigations"
        v-if="navigation.children"
        :key="navIndex">
        <div class="order">
          {{ navigation.order }}
        </div>
        <div class="first-nav">
          {{ navigation.name }}
        </div>
        <div class="second-nav-wrapper">
          <div
            class="second-nav regular"
            @click.stop="jumpPage(childNav)"
            v-for="(childNav, childIndex) in navigation.children"
            :key="childIndex">
            {{ childNav.name }}
          </div>
        </div>
        <div class="right-arrow" @click="jumpPage(navigation)">
          <img class="iconfont" src="~@/assets/images/enter_active.svg">
        </div>
      </div>
      <div class="close" @click="close">
        <img class="iconfont icon-close" src="~@/assets/images/close.svg">
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { setLang } from '@/utils'

  export default {
    name: 'navigations-map',
    components: {
    },
    computed: {
      navigations() {
        return this.$i18n.messages[this.$i18n.locale].messages.navigations
      },
      isCn() {
        return this.$i18n.locale === 'zh-CN'
      },
    },
    data() {
      return {
        langs: [
          {
            name: 'EN',
            type: 'en-US'
          },
          {
            name: '中',
            type: 'zh-CN'
          }
        ]
      }
    },
    methods: {
      ...mapMutations('home', [
        'SETUP_MAP_SHOW'
      ]),

      onMouseEnter(nav) {
        if (!nav.children) { return }
        const hasChildren = this.navigations.filter(navigation => navigation.children)
        const index = hasChildren.findIndex(item => item.name === nav.name)
        const wrappers = document.querySelectorAll('.navs-wrapper')
        wrappers.forEach((wrapper) => {
          wrapper.classList.remove('active')
        })
        wrappers[index].classList.add('active')
      },

      onMouseOut() {
        const wrappers = document.querySelectorAll('.navs-wrapper')
        wrappers.forEach((wrapper) => {
          wrapper.classList.remove('active')
        })
      },

      jumpPage(nav) {
        location.href = `${location.origin}${nav.path}`
        this.SETUP_MAP_SHOW({
          type: false
        })
      },

      jump(nav, childNav) {
        this.$router.push(`${nav.path}/${childNav.path}`)
        this.SETUP_MAP_SHOW({
          type: false
        })
      },

      langCheck(lang) {
        setLang(lang.type)
        this.$i18n.locale = lang.type
      },
      close() {
        this.SETUP_MAP_SHOW({
          type: false
        })
      },
    }
  }
</script>

<style lang="less" scoped>
@import '~@/styles/font';

  .navs-map {
    display: flex;
    flex-direction: row;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1002;
    color: #fff;
    background-image: linear-gradient(45deg, #1F253E 0%, #15193B 100%, #1D2352 100%);
    transition: all .6s;

    .navs-all {
      width: calc(~'180px + 5vw');
      padding: 20px 0 60px 2.5%;
      background-image: linear-gradient(150deg, #AB258B 0%, #7548F6 100%);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      position: relative;
      .logo {
        height: 36px;
        width: 176px;
        margin-bottom: 184px;
        margin-left: -4px;      
      }
      .primary-nav {
        opacity: 0.75;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 30px;
        cursor: pointer;
        &:hover {
          opacity: 1;
        }
      }
      .lang-check {
        position: absolute;
        bottom: 60px;
        >span {
          cursor: pointer;
          opacity: 0.7;
          &.lang-en-US {
            padding-right: 6px;
          }
          &.active {
            opacity: 1;
          }
        }
        .lang-zh-CN {
          padding-left: 6px;
          position: relative;
          &:before {
            content: '';
            display: inline-block;
            width: 1px;
            height: 16px;
            position: absolute;
            left: -2px;
            background: #fff;
          }
        }
      }
    }

    .navs-wrapper {
      flex-grow: 1;
      width: calc(~'19vw - 36px');
      height: 100%;
      color: #fff;
      border-left: 1px solid #333;
      position: relative;
      overflow: hidden;
      padding: 240px 0 0 2%;
      transition: all 0.8s ease-out;
      
      &:after {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-position: center;
        background-size: cover;
        z-index: -1;
        transition: all .7s;
        background-position: center right;
      }
      &.navs-order01:after {
        background-position: top right;
        background-image: url("~@/assets/images/Section1.png");
      }
      &.navs-order02:after {
        background-image: url("~@/assets/images/Section2.png");
      }
      &.navs-order03:after {
        background-image: url("~@/assets/images/Section3.png");
      }
      &.navs-order04:after {
        background-image: url("~@/assets/images/Section4.png");
      }
      &.navs-order05:after {
        background-image: url("~@/assets/images/Section5.png");
      }
      &:nth-child(2) {
        border-left: none;
      }

      .order {
        opacity: 0.15;
        font-family: DINCondensed;
        font-size: 86px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 40px;
        margin-left: calc(~'-2vw - 10px');
        margin-bottom: 12px;
        transition: all 0.8s ease-out;
      }

      .first-nav {
        letter-spacing: 0;
        line-height: 36px;
        margin-bottom: 36px;
        font-weight: 500;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0;
        cursor: pointer;
      }

      .second-nav {
        margin-bottom: 24px;
        font-size: 16px;
        color: #F5F5F5;
        line-height: 16px;
        cursor: pointer;
      }

      .right-arrow {
        position: absolute;
        bottom: 100px;
        //left: 62px;
        cursor: pointer;
        font-size: 25px;
        opacity: 0;
        transition: all .3s;
      }

      &.active {
        padding-left: 1.4vw;
        //transition: all 0.8s ease-out;

        .order {
          opacity: 0.2;
          margin-left: -1.2vw;
          //transition: all 0.8s ease-out;
        }

        .right-arrow {
          opacity: 1;
        }
        &:after{
          transform: scale(1.2);
        }
      }

      &:hover {
        padding-left: 1.4vw;
        //transition: all 0.8s ease-out;

        .order {
          opacity: 0.2;
          margin-left: -1.2vw;
          //transition: all 0.8s ease-out;
        }

        .right-arrow {
          opacity: 1;
        }

        &:after{
          transform: scale(1.2);
        }
      }
    }
    .close {
      position: absolute;
      right: 50px;
      top: 26px;
      font-size: 26px;
      cursor: pointer;
      img {
        width: 20px;
      }
    }
  }
  .slide-enter, .slide-leave-to {
    transform: translateY(-100%);
  }
  .slide-enter-to, .slide-leave {
    transform: translateY(0);
  }
</style>



// WEBPACK FOOTER //
// navigations-map.vue?2fb234cf